<template>
  <BaseModal
    :id="`Reorder`"
    :size="'md'"
    title="Reorder Post"
    @closeModal="closeModal"
    @openModal="openModal"
  >
    <vue-element-loading
      :active="isLoading"
      color="rgba(255, 255, 255, .0)"
      background-color="rgba(255, 255, 255, .2)"
    />

    <draggable
      :list="list"
      :options="{
        animation: 200,
        handle: '.draggable__icon'
      }"
      @change="updateOrder"
    >
      <div v-if="isFetching" class="mt-4 mb-4 d-flex justify-content-center">
        <b-spinner label="Loading..." variant="dark" />
      </div>
      <div
        v-for="item in list"
        v-else
        :id="`post-${$sanitize(item.description)}`"
        :key="item.description"
        class="list-group-item"
      >
        <font-awesome-icon
          icon="arrows-alt-v"
          :style="{ color: '#3C44B1', cursor: 'move' }"
          class="mr-3 draggable__icon"
        />
        {{
          $sanitize(item.description).length > 50
            ? $sanitize(item.description).substring(0, 50) + ' ...'
            : $sanitize(item.description)
        }}
        <b-popover
          v-if="$sanitize(item.description).length > 60"
          triggers="hover"
          :target="`post-${$sanitize(item.description)}`"
          placement="left"
        >
          {{ $sanitize(item.description) }}
        </b-popover>
      </div>

      <!-- <table
        class="table table-hover table-bordered rounded"
        v-if="items && items.length"
      >
        <tbody v-for="item in items" :key="item.id">
          <tr id="description-reorder">
            <th>
              <span>
                <font-awesome-icon
                  icon="arrows-alt-v"
                  :style="{ color: 'blue', cursor: 'move' }"
                  class="mr-3"
                />
              </span>
              <span :id="`item-id: ${item.id}`">
                {{ $sanitize(item.description) }}
              </span>
              <b-tooltip
                :target="`item-id: ${item.id}`"
                :title="$sanitize(item.description)"
                placement="topright"
              />
            </th>
          </tr>
        </tbody>
      </table> -->
    </draggable>
    <template slot="modal-footer">
      <b-button variant="link" class="btn-link-dark" @click="hide()"> Cancel </b-button>
      <b-button variant="success" @click="handleReorder()">
        <span v-if="!isLoading">Save</span>
        <span v-else class="pr-2 pl-2">
          <b-spinner label="Loading..." variant="secondary" small />
        </span>
      </b-button>
    </template>
  </BaseModal>
</template>

<script>
import { notificationMixin } from '@/mixins/notificationMixin';
import BaseModal from '@/components/base-components/BaseModal';

import { BButton } from 'bootstrap-vue';
import draggable from 'vuedraggable';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowsAltV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faArrowsAltV);

export default {
  name: 'BaseModalReorder',

  components: {
    BaseModal,
    BButton,
    draggable,
    FontAwesomeIcon
  },

  mixins: [notificationMixin],

  props: {
    items: {
      type: Array,
      default: () => []
    },
    isFetching: {
      type: Boolean
    }
  },

  data() {
    return {
      isLoading: false,
      list: []
    };
  },

  watch: {
    immediate: true,
    items: {
      handler(items) {
        if (items && items.length && !this.list.length) {
          this.initData();
        }
      }
    }
  },

  methods: {
    show() {
      this.$bvModal.show(`Reorder`);
    },
    hide() {
      this.$bvModal.hide(`Reorder`);
    },
    async handleReorder() {
      try {
        this.$emit('emitReorderItems', this.list);
        this.hide();
        this.notiSuccess('reorder', 'success');
      } catch (e) {
        console.log(e);
        this.notiError();
      }
    },
    // remove html tag in string
    // strippedString(originalString) {
    //   return originalString.replace(/(<([^>]+)>)/gi, "");
    // },

    updateOrder() {
      this.list.forEach((element, index) => {
        element.order = index + 1;
      });
    },

    closeModal() {},
    openModal() {
      this.initData();
    },

    initData() {
      this.list = [...this.items];
      this.updateOrder();
    }
  }
};
</script>

<style lang="scss" scoped>
.draggable__icon {
  cursor: move;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 0.5rem 1rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(7, 9, 25, 0.125);
}
</style>
